// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1FqvF","detailsBorder":"styles_detailsBorder__3HkhF"};